import Analemma from "@/components/Analemma";

function DisclosureSummary() {
  return (
    <summary className="flex cursor-pointer list-none items-center gap-5 py-2 outline-none [&::-webkit-details-marker]:hidden">
      <span>
        <span className="font-sans text-[0.7rem] uppercase tracking-[0.4em] text-[#8a6f52]">The sun's figure-eight</span>
        <span className="mt-1 block font-serif text-2xl md:text-3xl">Show the sun's yearly path</span>
      </span>
      <span
        aria-hidden
        className="mt-5 flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[#c0501b] font-sans text-2xl leading-none text-[#c0501b] transition-[transform,background-color,color] duration-300 group-hover:bg-[#c0501b] group-hover:text-[#f6efe3] group-open:rotate-45"
      >
        +
      </span>
    </summary>
  );
}

function AnalemmaText() {
  return (
    <div>
      <h3 className="font-serif text-2xl">The analemma</h3>
      <p className="mt-5 leading-relaxed text-[#5e4a35]">
        If you photographed the sun at the same clock time every day for a year, it would trace this exact
        shape in the sky. The horizontal axis is the equation of time — how far ahead or behind the sun is of
        your clock. The vertical axis is its declination — how far north or south it climbs. The small loop at
        the top is northern summer; the big loop at the bottom is northern winter, when Earth is closest to the
        sun and moves fastest.
      </p>
      <p className="mt-4 leading-relaxed text-[#5e4a35]">
        The orange dot is where the sun stands <em className="italic">today</em>. The open circle marks the next
        day the curve crosses the centre line, when the equation of time is zero.
      </p>
    </div>
  );
}

export default function AnalemmaSection({ now }: { now: Date }) {
  return (
    <section className="mt-20 border-t border-[#d9c9ad] pt-10">
      <details className="group" data-testid="solar-analemma-disclosure">
        <DisclosureSummary />
        <div className="mt-10 grid grid-cols-1 gap-10 md:grid-cols-[auto_1fr] md:gap-16">
          <div data-testid="solar-analemma">
            <Analemma now={now} />
          </div>
          <AnalemmaText />
        </div>
      </details>
    </section>
  );
}
